import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { PaymentValidatedComponent } from "./payment-validated/payment-validated.component";
import { BillingHistoryComponent } from "./billing-history/billing-history.component";
import { CreditCardComponent } from "./credit-card/credit-card.component";
import { MatTooltip } from "@angular/material/tooltip";
import { MatOption, MatSelect } from "@angular/material/select";
import { MatButtonToggle, MatButtonToggleGroup } from "@angular/material/button-toggle";
import { PaymentFailedComponent } from "./payment-failed/payment-failed.component";
import { RouterLink } from "@angular/router";
import { YearlyBillingComponent } from "./yearly-billing/yearly-billing.component";
import {
    LicenceUsageWithDiffComponent,
    YearlyBillingDetailsByTeamComponent
} from "./yearly-billing/yearly-billing-details-by-team.component";
import { MatSort, MatSortHeader } from "@angular/material/sort";

@NgModule({
    declarations: [
        BillingHistoryComponent,
        YearlyBillingComponent,
        YearlyBillingDetailsByTeamComponent,
        CreditCardComponent,
        PaymentValidatedComponent,
        PaymentFailedComponent
  ],
    imports: [
        CommonModule,
        FormsModule,
        TranslateModule,
        ReactiveFormsModule,
        MatTooltip,
        MatSelect,
        MatOption,
        MatButtonToggle,
        MatButtonToggleGroup,
        RouterLink,
        MatSort,
        MatSortHeader,
        LicenceUsageWithDiffComponent
    ]
})
export class TmBillingModule{
}